import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setJobPaymentType} from "./jobPaymentActions";
import {PAYMENT_TYPES} from "./jobPaymentReducer";
import JobPaymentPopupACHInputs from "./JobPaymentPopupACHInputs";
import JobPaymentPopupCardInputs from "./JobPaymentPopupCardInputs";

const JobPaymentPopupPaymentSelections = (props) => {

  const {paymentType, setJobPaymentType} = props;

  const isACH = paymentType === PAYMENT_TYPES.ACH;
  const isCard = paymentType === PAYMENT_TYPES.card;
  const index = Object.keys(PAYMENT_TYPES).indexOf(paymentType);

  return (
    <div className="job-payment__content relative job-payment__container">
      <div className="flex flex--center">
        <ul className="job-payment__methods flex fix-ul flex--center" data-index={index}>
          {Object.keys(PAYMENT_TYPES).map((method) => {
            const className = method === "payPal" ? "paypal" : method;
            const selected = method === paymentType;
            return (
              <li
                className={"job-payment__method flex flex--center" +
                  " method--" + className + (selected ? " job-payment__method--selected" : "")}
                onClick={() => setJobPaymentType(method)}
                key={method}>
                <div className="method-info__logo"/>
              </li>
            )
          })}
        </ul>
      </div>
      {isACH || isCard ? (
        <p className={"job-payment__text text-center" + (isACH ? " color-slateGray" : " color-red")}>
          <FormattedMessage id={isACH ? "paymentPopup.ACHText" : "paymentPopup.cardText"}/>
        </p>
      ) : null}
      {isACH ? <JobPaymentPopupACHInputs/> : null}
      {isCard ? <JobPaymentPopupCardInputs/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {paymentType} = store.jobPaymentState;

  return {
    paymentType,
  };
};

const mapDispatchToProps = {
  setJobPaymentType,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupPaymentSelections)
)
